export const BALLAD = 'Ballad';
export const COUNTRY = 'Country';
export const FOLK = 'Folk';
export const HIP_HOP = 'Hip-Hop';
export const KIDS = 'Kids';
export const PATRIOTIC = 'Patriotic';
export const R_AND_B = 'R&B';
export const ROCK = 'Rock';
export const SOUL = 'Soul';
export const TRADITIONAL = 'Traditional';
export const WESTERN = 'Western';

export const GENRES = [
	BALLAD,
	COUNTRY,
	FOLK,
	HIP_HOP,
	KIDS,
	PATRIOTIC,
	R_AND_B,
	ROCK,
	SOUL,
	TRADITIONAL,
	WESTERN,
];
